import React from 'react';
import { sendNotificationEmail } from '../../services/emailService';

// React component wrapper for email notifications
export const EmailNotificationComponent = () => {
  // This component doesn't render anything - it's just a utility wrapper
  return null;
};

// Hook for using email notifications in your components
export const useEmailNotifications = () => {
  const [sending, setSending] = React.useState(false);
  const [lastResult, setLastResult] = React.useState(null);

  const sendEmail = async (type, data) => {
    setSending(true);
    try {
      const result = await sendNotificationEmail(type, data);
      setLastResult(result);
      return result;
    } catch (error) {
      const errorResult = { success: false, error: error.message };
      setLastResult(errorResult);
      return errorResult;
    } finally {
      setSending(false);
    }
  };

  return {
    sendEmail,
    sending,
    lastResult
  };
};

// Specific notification functions for easy use
export const emailNotifications = {
  // 1. When admin accepts/rejects employer verification
  async notifyEmployerVerification(employerData, status, reason = '') {
    const type = status === 'approved' ? 'EMPLOYER_ACCEPTED' : 'EMPLOYER_REJECTED';
    return await sendNotificationEmail(type, { 
      employerData, 
      reason 
    });
  },

  // 2. When employer accepts/rejects student application
  async notifyStudentApplication(studentData, positionData, companyData, status) {
    const type = status === 'accepted' ? 'STUDENT_APPLICATION_ACCEPTED' : 'STUDENT_APPLICATION_REJECTED';
    return await sendNotificationEmail(type, {
      studentData,
      positionData,
      companyData
    });
  },

  // 3. When student accepts/declines employer offer
  async notifyStudentResponse(employerData, studentData, positionData, response, reason = '') {
    const type = response === 'accepted' ? 'STUDENT_ACCEPTED_OFFER' : 'STUDENT_DECLINED_OFFER';
    return await sendNotificationEmail(type, {
      employerData,
      studentData,
      positionData,
      reason
    });
  }
};

export default EmailNotificationComponent;